import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@akostm/orbit-ui';
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons';
@Component({
  selector: 'shared-global-error',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ButtonComponent],
  templateUrl: './global-error.component.html',
  styleUrl: './global-error.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalErrorComponent {
  readonly title = input<string>();
  readonly message = input<string>('SHARED.ERRORS.GLOBAL.MESSAGE');
  readonly hasReload = input<boolean>(true);
  readonly unknownError = input<boolean>(true);
  readonly computedTitle = computed(
    () =>
      this.title() ||
      (this.unknownError()
        ? 'SHARED.ERRORS.GLOBAL.UNKNOWN_ERROR_TITLE'
        : 'SHARED.ERRORS.GLOBAL.TITLE')
  );
  readonly reload = output<void>();
  readonly testId = input<string>();
  readonly refreshIcon = faArrowsRotate;
}
